import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContainerSize } from '@freelancer/ui/container';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { LogoSize } from '@freelancer/ui/logo';
import { Margin } from '@freelancer/ui/margin';
import { BackgroundColor } from '@freelancer/ui/page-layout';
import { FontColor, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-header',
  template: `
    <fl-bit class="PagePostProject-header">
      <fl-container [size]="ContainerSize.TABLET">
        <fl-bit class="PagePostProject-container">
          <fl-bit
            [flMarginBottom]="Margin.SMALL"
            [flMarginBottomDesktop]="Margin.XLARGE"
          >
          </fl-bit>
          <fl-bit class="PagePostProject-logo">
            <fl-link flTrackingLabel="PostJobPageLogo" [link]="'/'">
              <fl-logo
                [flHideMobileSmall]="true"
                [size]="LogoSize.SMALL"
                [backgroundColor]="BackgroundColor.DARK"
                [flMarginBottom]="Margin.SMALL"
                [flMarginBottomDesktop]="Margin.XLARGE"
              ></fl-logo>
            </fl-link>
          </fl-bit>
          <fl-heading
            i18n="Post Job Page Form heading"
            [color]="HeadingColor.LIGHT"
            [flMarginBottom]="Margin.SMALL"
            [flMarginBottomDesktop]="Margin.MID"
            [headingType]="HeadingType.H1"
            [size]="TextSize.LARGE"
            [sizeDesktop]="TextSize.XLARGE"
          >
            Tell us what you need done
          </fl-heading>
          <fl-text
            class="PagePostProject-header-desc"
            i18n="Post Job Page Form heading description"
            [flHideMobileSmall]="true"
            [color]="FontColor.LIGHT"
          >
            Contact skilled freelancers within minutes. View profiles, ratings,
            portfolios and chat with them. Pay the freelancer only when you are
            100% satisfied with their work.
          </fl-text>
        </fl-bit>
      </fl-container>
    </fl-bit>
  `,
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  BackgroundColor = BackgroundColor;
  ContainerSize = ContainerSize;
  FontColor = FontColor;
  HeadingColor = HeadingColor;
  TextSize = TextSize;
  HeadingType = HeadingType;
  LogoSize = LogoSize;
  Margin = Margin;
}
